'use strict';

angular.module('casist.admin', []);